import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { CurrencyProvider } from "@/contexts/CurrencyContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import Landing from "@/pages/Landing";
import Store from "@/pages/Store";
import ProductDetail from "@/pages/ProductDetail";
import EventsPage from "@/pages/EventsPage";
import TrainingPage from "@/pages/TrainingPage";
import ContactPage from "@/pages/ContactPage";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import TrainingDetail from "@/pages/TrainingDetail";
import Gallery from "@/pages/Gallery";
import AboutPage from "@/pages/AboutPage";
import EventDetail from "@/pages/EventDetail";
import PaymentResult from "@/pages/PaymentResult";
import RegistrationSuccess from "@/pages/RegistrationSuccess";
import ConsentSign from "@/pages/ConsentSign";

function App() {
  return (
    <LanguageProvider>
    <CurrencyProvider>
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#050505] text-white">
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/tienda" element={<Store />} />
            <Route path="/tienda/producto/:id" element={<ProductDetail />} />
            <Route path="/eventos" element={<EventsPage />} />
            <Route path="/eventos/:eventId" element={<EventDetail />} />
            <Route path="/entrenamientos" element={<TrainingPage />} />
            <Route path="/entrenamientos/:planId" element={<TrainingDetail />} />
            <Route path="/galeria" element={<Gallery />} />
            <Route path="/nosotros" element={<AboutPage />} />
            <Route path="/contacto" element={<ContactPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/payment/success" element={<PaymentResult status="success" />} />
            <Route path="/payment/failure" element={<PaymentResult status="failure" />} />
            <Route path="/payment/pending" element={<PaymentResult status="pending" />} />
            <Route path="/inscripcion-exitosa" element={<RegistrationSuccess />} />
            <Route path="/firmar-consentimiento/:regId" element={<ConsentSign />} />
          </Routes>
          <Footer />
          <WhatsAppFab />
          <Toaster theme="dark" position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
    </CurrencyProvider>
    </LanguageProvider>
  );
}

export default App;
